import React from 'react';
import { IconType } from '../../Icons/HudIcons';

import * as Styled from './TagsInput.styles';
import { Option } from '../MultiSelect';

interface TagsInputProps extends React.HTMLAttributes<HTMLDivElement> {
  placeholder?: string;
  tags: Option[];
  onClick?: () => void;
  onRemove?: (tag: Option) => void;
  rightIcon?: IconType | null;
}

function TagsInput({
  tags,
  placeholder,
  onClick,
  onRemove,
  rightIcon = 'menu.caretDown',
  ...rest
}: TagsInputProps) {
  const showPlaceholder = !tags.length && placeholder;

  return (
    <Styled.Container onClick={onClick} {...rest}>
      {showPlaceholder && (
        <Styled.Placeholder>{placeholder}</Styled.Placeholder>
      )}
      <Styled.TagsGroup>
        {tags.map((tag) => (
          <Styled.Tag
            key={tag.value}
            onClick={(event) => event.stopPropagation()}
          >
            {tag.label}
            <Styled.CloseIcon
              icon="other.close"
              onClick={() => onRemove?.(tag)}
            />
          </Styled.Tag>
        ))}
      </Styled.TagsGroup>
      {rightIcon && <Styled.CaretIcon icon={rightIcon} />}
    </Styled.Container>
  );
}

export default TagsInput;
